import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { LanguageProvider } from './contexts/LanguageContext';
import { LanguageSwitcher } from './components/LanguageSwitcher';
import { LandingPage } from './components/LandingPage';
import { TermsOfService } from './components/TermsOfService';
import { PrivacyPolicy } from './components/PrivacyPolicy';
import { PricingPage } from './components/PricingPage';

function App() {
    return (
        <LanguageProvider>
            <BrowserRouter>
                <LanguageSwitcher />
                <Routes>
                    <Route path="/" element={<LandingPage />} />
                    <Route path="/terms" element={<TermsOfService />} />
                    <Route path="/privacy" element={<PrivacyPolicy />} />
                    <Route path="/pricing" element={<PricingPage />} />
                </Routes>
            </BrowserRouter>
        </LanguageProvider>
    );
}

export default App;
